module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("argoG"))).then(() => parcelRequire('hEqeo'));